import type { operations } from "@fluid-app/checkout-api-client";

type StoreAddressFieldsQuery =
  operations["checkout_v2026_04_get_store_address_fields"]["parameters"]["query"];

export function createAddressFieldsQuery(
  languageIso?: string,
): StoreAddressFieldsQuery | undefined {
  return languageIso ? { language_iso: languageIso } : undefined;
}
